import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { StatsBar } from '../components/StatsBar';
import { Services } from '../components/Services';
import { Gallery } from '../components/Gallery';
import { Process } from '../components/Process';
import { ServiceAreas } from '../components/ServiceAreas';
import { Testimonials } from '../components/Testimonials';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-white font-heading antialiased" data-id="element-239" data-mp="24hagjnsi78e3">
      <Header data-id="element-240" data-mp="29fc0eaxr7bqm" />
      <main data-id="element-241" data-mp="29etusnp7bl61">
        <Hero data-id="element-242" data-mp="29i80a4t5wahp" />
        <StatsBar data-id="element-243" data-mp="2dhqi2rpos5gb" />
        <Services data-id="element-244" data-mp="2di8bzhovm7l2" />
        <Gallery data-id="element-245" data-mp="2dirt4w6pcry1" />
        <Process data-id="element-246" data-mp="2dj9ycibcegi3" />
        <ServiceAreas data-id="element-247" data-mp="2dfm6dnljq25h" />
        <Testimonials data-id="element-248" data-mp="3kvac6mkbgbvj" />
        <ContactSection data-id="element-249" data-mp="3kw1xn4k78t83" />
      </main>
      <Footer data-id="element-250" data-mp="3kv0nr3ex6cry" />
    </div>;
}